var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClothes2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 192,
    viewBox: "0 0 166 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.901 33.8708C109.901 21.957 117.666 12.3077 127.254 12.3077C135.653 12.3077 142.705 19.7908 144.21 29.7354L157.284 101.317C159.344 112.64 153.639 123.865 144.527 126.523C135.415 129.182 126.382 122.191 124.163 110.868L110.297 38.2031C110.033 36.8247 109.901 35.3806 109.901 33.8708Z",
    fill: "#7D7BC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.83 155.569L124.48 112.542C122.42 101.12 128.125 89.8954 137.237 87.237C146.349 84.677 155.461 91.6677 157.601 102.892L166 146.806L133.83 155.569Z",
    fill: "#7D7BC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.83 155.569L130.898 142.08L163.465 133.218L166 146.806L133.83 155.569Z",
    fill: "#A6A6E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5744 38.2031L42.6288 110.868C40.4895 122.191 31.3773 129.182 22.2651 126.523C13.153 123.865 7.44797 112.64 9.50812 101.317L22.5821 29.7354C24.0876 19.7908 31.1396 12.3077 39.6179 12.3077C49.1262 12.3077 56.8914 21.957 56.8914 33.8708C56.8914 35.3806 56.7857 36.8247 56.5744 38.2031Z",
    fill: "#7D7BC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.79248 146.806L9.19152 102.892C11.4101 91.6677 20.4431 84.677 29.5552 87.237C38.6674 89.8954 44.3724 101.12 42.3122 112.542L32.9624 155.569L0.79248 146.806Z",
    fill: "#7D7BC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.79248 146.806L3.40728 133.218L35.8941 142.08L32.9624 155.569L0.79248 146.806Z",
    fill: "#A6A6E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.641 145.329H33.9131L34.547 12.997L66.3207 6.10352e-05L70.5 2.5L76.5 4L81.5 4.5L87 4L92.5 2.5L98.0152 6.10352e-05L132.641 13.3908V145.329Z",
    fill: "#7D7BC7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.641 145.329H33.9131L34.547 12.9969L73 36.5L85.5 31L132.641 13.3908V145.329Z",
    fill: "#7D7BC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6264 145.329L34.3887 52.1847",
    stroke: "#6666B2",
    strokeWidth: 2.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.771 145.329L131.691 52.1847",
    stroke: "#6666B2",
    strokeWidth: 2.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothes2);
export default __webpack_public_path__ + "static/media/clothes-2.82ba9173983be2580bc0980f5b2cd1e5.svg";
export { ForwardRef as ReactComponent };